export const FILTER_CONSTANTS = {
  EXPRESS_DELIVERY_COLLECTION_PATH: 'collection/express-delivery+cars/',
  
  EXCLUDED_FILTER_KEYS: ['is_express_delivery', 'is_hot_deal', 'budget_range'],
  STATIC_FILTER_KEYS: ['sort_by', 'brand_model', 'body_type', 'fuel_type', 'transmission', 'budget', 'feature', 'seat_capacity'],
  
  FILTER_TITLE_MAPPINGS: {
    sort_by: 'Sort By',
    brand_model: 'Brand',
    body_type: 'Body Type', 
    fuel_type: 'Fuel Type',
    transmission: 'Transmission',
    budget: 'Budget',
    seat_capacity: 'Seating Capacity',
    feature: 'Features',
    is_express_delivery: 'Express Delivery'
  } as const,
  
  FILTER_TYPES: {
    SORT: 'sort',
    OPTIONS: 'options', 
    RANGE: 'range',
    TOGGLE: 'toggle'
  } as const,
  
  SINGLE_SELECT_CATEGORIES: ['sort_by'] as const,
  
  HIERARCHICAL_CATEGORIES: ['brand_model', 'body_type'] as const,
  
  BUDGET_CONFIG: {
    DEFAULT_STEP: 100000
  }
} as const;

export type FilterCategory = keyof typeof FILTER_CONSTANTS.FILTER_TITLE_MAPPINGS;
export type FilterType = typeof FILTER_CONSTANTS.FILTER_TYPES[keyof typeof FILTER_CONSTANTS.FILTER_TYPES]; 